import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';
import { GetUserIdentityConflictsRequest } from '~src/authentication/serverApi/requests/GetUserIdentityConflictsRequest';
import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '~src/httpClient/resources/Resource';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';


class UserIdentityConflictsResource implements IListResource<IUserIdentityConflictInfo> {

  private listFetcher: IListFetcher<IUserIdentityConflictInfo> = new WebClientListResourceFetcher(GetUserIdentityConflictsRequest, ServerApiMapper.userIdentityConflicts);

  public all(): ResourceQuery<IUserIdentityConflictInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const UserIdentityConflicts = new UserIdentityConflictsResource();
